import React, { Component } from 'react';

import PaginationComponent from '../components/PaginationComponent';
import TableStateCard from '../components/TableStateCard';
import { sortClass, nextSortDir, sortAriaSort } from '../utils/table';
import dateFormat from 'dateformat';
import { RESTOCKING_PAYMENT_STATUS } from '../utils/enums';
import { convertToMoney, getTextColorRestockingPayment } from '../utils/formats';
import { getSelectedBranchId } from '../utils/branch';
import { buildPaginationQuery, getPaginatedData, scheduleDebouncedCallback, clearDebouncedCallback } from '../utils/pagination';
import { hasActiveSearch, getSearchEmptyMessage } from '../utils/tableState';

var config = process.env;

// ENI-199: retail e insumos comparten la tabla de reposiciones; la prop `type`
// ('retail' | 'supplies') elige de qué lado está esta grilla. Sin ella el listado de
// retail mostraba también las reposiciones de insumos.
const UNIT_LABELS = { g: 'g', ml: 'ml', unit: 'u' };

// ENI-190: en una reposición de insumos la cantidad son PAQUETES cerrados, no unidades
// base. "3" a secas se lee como 3 gramos; se muestra "3 paq. (1000 g c/u)".
function formatQuantity(item) {
    const quantity = item.quantity;
    if (item.packageSize == null) {
        return quantity;
    }
    const size = Number(item.packageSize);
    const unit = UNIT_LABELS[item.baseUnit] || item.baseUnit || '';
    const label = `${quantity} paq.`;
    return size > 1 ? `${label} (${size} ${unit} c/u)` : label;
}



class TableRestockingComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            quantityShowRows: 25,
            currentPage: 1,
            totalItems: 0,
            search: '',
            searchInput: '',
            sortBy: 'id',
            sortDir: 'desc',
            data: [],
            loaded: false,
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    componentWillUnmount() {
        clearDebouncedCallback(this, 'searchDebounceTimeout');
    }

    componentDidUpdate(prevProps) {
        if (this.props.type !== prevProps.type) {
            this.fetchData({ page: 1 });
            return;
        }
    }

    fetchData = ({
        page = this.state.currentPage,
        limit = this.state.quantityShowRows,
        search = this.state.search,
        sortBy = this.state.sortBy,
        sortDir = this.state.sortDir,
        showLoader = true,
    } = {}) => {
        if (showLoader) {
            this.setState({ loaded: false });
        }
        const selectedBranchId = getSelectedBranchId();
        const query = buildPaginationQuery({
            page,
            limit,
            search,
            sortBy,
            sortDir,
            extraParams: {
                branchId: selectedBranchId || undefined,
                type: this.props.type || undefined,
            },
        });

        const request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };

        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}restocking?${query}`, request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
                return;
            }

            const paginatedData = getPaginatedData(data);
            this.setState(() => {
                return {
                    data: paginatedData.items || [],
                    quantityShowRows: paginatedData.limit || Number(limit),
                    currentPage: paginatedData.page || Number(page),
                    totalItems: paginatedData.total || 0,
                    search,
                    sortBy,
                    sortDir,
                    loaded: true,
                };
            });
        });
    }

    createModals = () => {
        if (!this.state.loaded) {
            return null;
        }

        return <div>{this.state.data.map((data) => this.createModalView(data))}</div>;
    }

    createModalView = (data) => {
        return (
            <div className="modal fade" id={`modal-view-${data.id}`} role="dialog" key={`modal-view-${data.id}`}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" style={{ textAlign: 'center' }}>{this.props.type === 'supplies' ? 'Reposición de insumos' : 'Reposición'}</h4>
                        </div>
                        <div className="modal-body" style={{ padding: '0' }}>
                            <ul style={{ marginTop: '20px' }}>
                                <li><b>Identificador:</b> {data.id}</li>
                                <li><b>Fecha:</b> {dateFormat(data.date, 'dS mmmm, yyyy')}</li>
                                <li><b>Proveedor:</b> {data.providerName || '-'}</li>
                                {/* Sin factura, paymentStatus viene null y RESTOCKING_PAYMENT_STATUS[null]
                                    es undefined: renderizaba vacío y se leía como pantalla rota. */}
                                <li><b>Estado del pago:</b> {data.providerInvoiceId
                                    ? <span id={`item-status-li-${data.id}`} className={getTextColorRestockingPayment(data.paymentStatus)}>{RESTOCKING_PAYMENT_STATUS[data.paymentStatus]}</span>
                                    : <span id={`item-status-li-${data.id}`} className="text-muted">Sin factura — no genera deuda</span>}</li>
                                <li><b>Precio total:</b> ${convertToMoney(data.totalPrice)}</li>
                                <li><b>Factura:</b> {data.invoiceId}</li>
                                <li><b>Link de Factura:</b> {data.invoiceLink}</li>
                                <li><b>Total de Factura:</b> {data.invoiceAmount != null ? data.invoiceAmount : data.invoiceTotal}</li>
                            </ul>
                            <table className="transaction-history d-none dataTable no-footer dtr-inline" role="grid">
                                <thead>
                                    <tr role="row">
                                        <th style={{ width: '20%' }}>Código</th>
                                        <th style={{ width: '30%' }}>{this.props.type === 'supplies' ? 'Insumo' : 'Producto'}</th>
                                        <th style={{ width: '10%' }}>Cantidad</th>
                                        <th style={{ width: '20%' }}>Costo unitario</th>
                                        <th style={{ width: '20%' }}>Costo total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(data.items || []).map((element, index) => (
                                        <tr role="row" className="odd" key={`${data.id}-${element.code}-${index}`} style={{ background: index % 2 === 0 ? '#ffffff' : '#fcfcfc' }}>
                                            <td>{element.code}</td>
                                            <td>{element.name}</td>
                                            <td>{formatQuantity(element)}</td>
                                            <td>${convertToMoney(element.unitPrice)}</td>
                                            <td>${convertToMoney(element.quantity * element.unitPrice)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="mb-2 mr-1 btn btn-primary btn-sm"
                                data-dismiss="modal">
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    drawRow = (item, index) => {
        return(
            <tr role="row" className="odd" key={item.id} style={{ background: index % 2 == 0 ? '#ffffff' : '#fcfcfc' }}>
                <td tabIndex="0" className="sorting_1">{item.id}</td>
                <td>{dateFormat(item.date, 'dS mmmm, yyyy')}</td>
                <td>{item.providerName || '-'}</td>
                {/* ENI-32: el estado se hereda de la factura. Sin factura NO es "pendiente":
                    es que no se debe nada — el caso de la mercadería en consignación. */}
                <td id={`item-status-${item.id}`}>
                    {item.providerInvoiceId ? (
                        <span className={getTextColorRestockingPayment(item.paymentStatus)}>
                            {RESTOCKING_PAYMENT_STATUS[item.paymentStatus]}
                        </span>
                    ) : (
                        <span className="text-muted" title="No tiene factura asociada, así que no genera deuda">
                            Sin factura
                        </span>
                    )}
                </td>
                <td>${convertToMoney(item.totalPrice)}</td>
                <td>{item.invoiceNumber || item.invoiceId || '-'}</td>
                <td style={{ display: this.props.role == 2 ? 'none' : 'table-cell' }}>
                    <div className="btn-group btn-group-sm" role="group" aria-label="Table row actions">
                        <button
                            data-toggle="modal"
                            data-target={`#modal-view-${item.id}`}
                            type="button"
                            className="btn btn-white">
                            <i className="material-icons">remove_red_eye</i>
                        </button>
                    </div>
                </td>
            </tr>
        );
    }

    loadData = () => {
        if (!this.state.loaded) {
            return <tbody></tbody>;
        }

        const items = this.state.data.map((item, index) => this.drawRow(item, index));
        if (items.length === 0) {
            items.push(
                <tr key="empty"><td colSpan="7" style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)' }}>
                    {getSearchEmptyMessage(this.state.searchInput || this.state.search)}
                </td></tr>
            );
        }

        return <tbody>{items}</tbody>;
    }

    onChangeShowRows = () => {
        const itemSelected = Number(document.getElementById('select_rows').value);
        this.fetchData({ page: 1, limit: itemSelected });
    }

    onChangeInput = (search) => {
        this.setState({ searchInput: search });
        scheduleDebouncedCallback(this, 'searchDebounceTimeout', () => {
            this.fetchData({ page: 1, search, showLoader: false });
        });
    }

    orderData = (column) => {
        this.fetchData({
            page: 1,
            sortBy: column,
            sortDir: nextSortDir(column, this.state.sortBy, this.state.sortDir),
        });
    }

    // Props de una cabecera ordenable: la clase y el aria-sort se derivan del state, así que
    // sobreviven al remonte que provoca el loader.
    sortableHeader = (column) => ({
        onClick: () => this.orderData(column),
        className: sortClass(column, this.state.sortBy, this.state.sortDir),
        'aria-sort': sortAriaSort(column, this.state.sortBy, this.state.sortDir),
        tabIndex: '0',
    })

    render() {
        const searchActive = hasActiveSearch(this.state.searchInput, this.state.search);

        if (!this.state.loaded) {
            return <TableStateCard loading />;
        }

        if (this.state.totalItems === 0 && !searchActive) {
            return (
                <div>
                    <TableStateCard
                        icon={this.props.type === 'supplies' ? 'kitchen' : 'inventory_2'}
                        title={this.props.type === 'supplies'
                            ? 'Todavia no hay reposiciones de insumos'
                            : 'Todavia no hay reposiciones para mostrar'}
                        message={this.props.type === 'supplies'
                            ? 'Las reposiciones de insumos se cargan desde Insumos, con el boton "Reponer". Aca vas a ver proveedor, estado de pago, costo total y factura de cada una.'
                            : 'Cuando existan reposiciones registradas, aca vas a ver proveedor, estado de pago, costo total y factura.'}
                    />
                    {this.createModals()}
                </div>
            );
        }

        return (
            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                <div className="dataTables_length" id="DataTables_Table_0_length">
                    <label>Show
                    <select id="select_rows" name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" value={this.state.quantityShowRows} onChange={() => this.onChangeShowRows()}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select> entries</label>
                </div>
                <div id="DataTables_Table_0_filter" className="dataTables_filter">
                    <label>Search:
                    <input id="input_search" type="search" className="" placeholder="" aria-controls="DataTables_Table_0" value={this.state.searchInput} onChange={(e) => this.onChangeInput(e.target.value)}/>
                    </label>
                </div>

                <table className="transaction-history d-none dataTable no-footer dtr-inline" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                    <thead>
                        <tr role="row">
                            {/* La columna de checkboxes no ordena nada: traía className="sorting" sin onClick. */}
                            <th {...this.sortableHeader('id')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>ID</th>
                            <th {...this.sortableHeader('date')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '25%' }}>Fecha</th>
                            <th {...this.sortableHeader('providerName')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '20%' }}>Proveedor</th>
                            <th {...this.sortableHeader('paymentStatus')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Estado del pago</th>
                            <th {...this.sortableHeader('totalPrice')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Costo total</th>
                            <th {...this.sortableHeader('invoiceId')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Factura</th>
                            <th tabIndex="0" aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%', display: this.props.role == 2 ? 'none' : 'table-cell' }}>Acciones</th>
                        </tr>
                    </thead>
                    {this.loadData()}
                </table>

                {this.createModals()}

                <PaginationComponent
                    totalItems={this.state.totalItems}
                    quantityRows={this.state.quantityShowRows}
                    currentPage={this.state.currentPage}
                    onPageChange={(page) => this.fetchData({ page })}
                />
            </div>
        );
    }
}

export default TableRestockingComponent;
